import Button from '@atoms/Button/Button';
import IconPageLink from '@atoms/IconPageLink/IconPageLink';
import { IAccountNavigation } from '@models/IAccountNavigation';
import updateDataLayer from '@utils/helpers/gtm';

const AccountNavigation = ({
  items,
  signOutCta,
  signOutEndpoint,
}: IAccountNavigation) => (
  <aside
    className="flex flex-col items-start gap-7.5"
    data-testid="CT-97-Account-Navigation"
  >
    {items?.map((item, index) => (
      <IconPageLink
        key={`${item.label}--account-page-link`}
        {...item}
        dataTestId={`CT-97-Account-Navigation-Page-Link-${index}`}
        linkCallback={() => {
          updateDataLayer({
            event: 'menuUsed',
            content_type: 'Account',
            main_category: item.label,
          });
        }}
      />
    ))}
    {signOutCta && signOutEndpoint && (
      <Button
        link={{ name: signOutCta, url: signOutEndpoint }}
        className="mt-2.5 dark:text-black-100"
        secondary
        dataTestId="CT-97-Account-Navigation-Sign-Out-CTA"
      />
    )}
  </aside>
);

export default AccountNavigation;
